import { render, staticRenderFns } from "./Komentari.vue?vue&type=template&id=fd7fa196&scoped=true&"
import script from "./Komentari.vue?vue&type=script&lang=ts&"
export * from "./Komentari.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7fa196",
  null
  
)

export default component.exports